import { FileText, Download, Save } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { LetterPreview } from "./letter/LetterPreview";
import { AlternatesEditor } from "./letter/AlternatesEditor";
import { StationeryPanel } from "./letter/StationeryPanel";
import { LetterFields, CompanyProfile } from "./letter/LetterFields";
import { useBidLetter } from "@/hooks/useBidLetter";

const btn = "px-3 py-1.5 rounded-md text-xs inline-flex items-center gap-1.5";

export function BidLetterDialog({ projectId, projectName, runId, open, onOpenChange, canEdit }) {
  const { can } = useAuth();
  const b = useBidLetter({ projectId, projectName, runId, open });
  const { L, busy } = b;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-950 border-slate-800 text-slate-100 max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="bid-letter-dialog">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><FileText className="w-4 h-4 text-amber-400" /> Bid Clarification Letter</DialogTitle></DialogHeader>
        {!L ? <div className="text-slate-400 text-sm">Building letter…</div> : (
          <>
            <LetterFields L={L} form={b.form} setForm={b.setForm} contacts={b.contacts} canEdit={canEdit} includeScope={b.includeScope} setIncludeScope={b.setIncludeScope} />
            <AlternatesEditor alts={b.alts} setAlts={b.setAlts} canEdit={canEdit} />
            <CompanyProfile company={b.company} setCompany={b.setCompany} canAdmin={can("admin")} saveCompany={b.saveCompany} />
            <StationeryPanel L={L} canAdmin={can("admin")} previews={b.previews} upload={b.upload} removeImg={b.removeImg} />
            <div className="flex flex-wrap items-center gap-2 justify-between">
              <div className="text-[11px] font-mono text-slate-500" data-testid="letter-counts">{L.include_scope && <>{L.sections.scope}. {L.counts.included} included · </>}{L.sections.standard}. {L.counts.standard} standard exclusions · {L.sections.struck}. {L.counts.struck} struck requirements · {L.sections.clarifications}. {L.counts.clarifications} clarifications</div>
              <div className="flex gap-2">
                {canEdit && <button onClick={b.save} disabled={!!busy} className={`border border-slate-700 hover:border-amber-500 ${btn}`} data-testid="letter-save-button"><Save className="w-3.5 h-3.5" /> {busy === "save" ? "…" : "Save"}</button>}
                <button onClick={() => b.download("docx")} disabled={!!busy} className={`border border-slate-700 hover:border-amber-500 ${btn}`} data-testid="letter-docx-button"><Download className="w-3.5 h-3.5" /> DOCX</button>
                <button onClick={() => b.download("pdf")} disabled={!!busy} className={`bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold ${btn}`} data-testid="letter-pdf-button"><Download className="w-3.5 h-3.5" /> PDF</button>
              </div>
            </div>
            <LetterPreview L={L} />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
